import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants'

const SELECTORS = {
  element: '.js-feature-scroll',
  mediaWrapper: '.js-feature-scroll-media'
}

class FeatureScroll {
  constructor (element) {
    this.element = element
    this.mediaWrapper = this.element.querySelector(SELECTORS.mediaWrapper)
    this.media = this.mediaWrapper.querySelector('img, video, iframe')
    this.caption = this.mediaWrapper.querySelector('.media-caption')
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.init()
  }

  init() {
    if (this.media) {
      if (this.isMediaLoaded()) {
        this.setHeightVar()
      } else {
        this.setOnLoad()
      }
    }
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, () => this.setHeightVar())
  }

  setHeightVar() {
    const mediaHeight = this.mediaWrapper.offsetHeight
    let captionHeight = 0
    if (this.caption) {
      const styles = getComputedStyle(this.caption)
      captionHeight += this.caption.offsetHeight
      captionHeight += parseInt(styles.marginTop) || 0
      this.element.style.setProperty('--caption-height', `${captionHeight}px`)
    }

    this.element.style.setProperty('--media-height', `${mediaHeight + captionHeight}px`)
  }

  isMediaLoaded() {
    if (this.media.nodeName === 'VIDEO') {
      return this.media.readyState >= 1
    } else if (this.media.nodeName === 'IMG') {
      return this.media.complete
    } else if (this.media.nodeName === 'IFRAME') {
      return true
    }

    return false
  }

  setOnLoad() {
    if (this.media.nodeName === 'VIDEO') {
      this.media.addEventListener('loadeddata', () => {
        if (this.media.readyState >= 1) {
          this.setHeightVar()
        }
      })
    } else if (this.media.nodeName === 'IMG') {
      this.media.addEventListener('load', () => {
        this.setHeightVar()
      })
    }
  }
}

export default {
  selector: SELECTORS.element,
  Source: FeatureScroll
}
